import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { useTranslation } from 'react-i18next';
import { LoopNoItemsState } from '@/common/components/empty-state/LoopNoItemsState';
import { useViewSurfacePaths } from '@/features/views/hooks/useViewSurfacePaths';

export const VisualizationNoItemsState = ({
  visualizationType,
}: {
  visualizationType: VisualizationType;
}) => {
  const { t } = useTranslation();
  const { isMergedPortfolio } = useViewSurfacePaths();

  const description =
    visualizationType === 'swimlane'
      ? t(($) => $.views.swimlane.emptyStates.noItems.description)
      : visualizationType === 'timeline'
        ? t(($) =>
            isMergedPortfolio
              ? $.views.roadmap.emptyStates.noItems.description
              : $.views.timeline.emptyStates.noItems.description,
          )
        : visualizationType === 'table'
          ? t(($) => $.views.table.emptyStates.noItems.description)
          : visualizationType === 'nodeGraph'
            ? t(($) => $.views.nodeGraph.emptyStates.noItems.description)
            : undefined;

  return <LoopNoItemsState description={description} />;
};
